<script lang="ts">
  import { Col, Row, Table } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import AlertsBody from "./AlertsBody.svelte";
</script>
<Col sm="12">
    <Card headerTitle={"Alerts"}>
      <div slot="contentbody">
        <Row class="card-block">
          <Col sm="12" lg="12" xl="12">
            <div class="table-responsive">
              <Table bordered>
                <tbody>
                  <AlertsBody />
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
</Col>